import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import Editor from "../../components/Editing/Editor";
import { hasWriteAccess } from "../../utils/utils";
import { EditActions, editActions } from "../../actions/editActions";
import DropdownField from "../../components/Editing/DropdownField";
import { getBaseEnumOptions } from "../../utils/pdApiUtils";

type StateProps = {
  editedStandardNode: Api.StandardNode;
  storedStandardNode: Api.StandardNode;
  pdApi: State.PdApi;
  activeUser: Api.User | undefined;
};

type DispatchProps = {
  editActions: typeof editActions;
};

type OwnProps = {
  toggleConfirm: () => void;
};

export type EditStandardNodeProps = StateProps & DispatchProps & OwnProps;

export class EditStandardNode extends React.Component<EditStandardNodeProps> {
  render(): JSX.Element {
    const {
      editedStandardNode,
      storedStandardNode,
      activeUser,
      toggleConfirm,

      pdApi
    } = this.props;
    const isNew = !storedStandardNode;
    const cpuOptions = getBaseEnumOptions(pdApi.ioCpuEnums);
    const networkOptions = getBaseEnumOptions(pdApi.ioNetworks);

    return (
      <Editor
        itemName={"Standard Node"}
        originalObject={storedStandardNode}
        editedObject={editedStandardNode}
        hasWritePermission={hasWriteAccess(activeUser, "Lift")}
        isValid={true}
        cancel={this.props.editActions.cancelEditing}
        update={() => this.props.editActions.update("standardNodes" as Api.OptionsGrud)}
        create={() => this.props.editActions.add("standardNodes" as Api.OptionsGrud)}
        remove={{ callback: toggleConfirm, disabled: isNew }}
      >
        <DropdownField
          id="cpu"
          label="Cpu"
          value={editedStandardNode.cpu.enumValue}
          options={cpuOptions}
          onChange={index => {
            const cpu = pdApi.ioCpuEnums[index];
            this.props.editActions.setEdited({ ...editedStandardNode, cpu: cpu });
          }}
        />
        <DropdownField
          id="network"
          label="Network"
          value={editedStandardNode.network.enumValue}
          options={networkOptions}
          onChange={index => {
            const network = pdApi.ioNetworks[index];
            this.props.editActions.setEdited({ ...editedStandardNode, network: network });
          }}
        />
      </Editor>
    );
  }
}

const mapStateToProps = (state: State.Root) => ({
  editedStandardNode: state.editView.editedObject,
  storedStandardNode: state.editView.storedObject,
  pdApi: state.pdApi,
  activeUser: state.main.activeUser
});

const mapDispatchToProps = (dispatch: Dispatch<EditActions>) => ({
  editActions: bindActionCreators({ ...editActions }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(EditStandardNode);


